var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49961 0.5C8.89758 0.499944 10.2678 0.890614 11.4555 1.62792C12.6432 2.36523 13.6012 3.41983 14.2214 4.6727C14.8416 5.92558 15.0993 7.32686 14.9654 8.71841C14.8315 10.11 14.3113 11.4364 13.4636 12.548L18.2066 17.293C18.386 17.473 18.4901 17.7144 18.4978 17.9684C18.5056 18.2223 18.4164 18.4697 18.2484 18.6603C18.0803 18.8508 17.8461 18.9703 17.5931 18.9944C17.3402 19.0185 17.0876 18.9454 16.8866 18.79L16.7926 18.707L12.0476 13.964C11.1006 14.6861 9.99527 15.1723 8.82305 15.3824C7.65083 15.5925 6.44543 15.5204 5.30661 15.1721C4.16778 14.8238 3.12826 14.2094 2.27406 13.3795C1.41986 12.5497 0.775549 11.5285 0.394433 10.4002C0.0133168 9.27192 -0.0936444 8.06912 0.0823999 6.89131C0.258444 5.7135 0.712432 4.59454 1.4068 3.62703C2.10117 2.65951 3.01595 1.87126 4.07545 1.32749C5.13495 0.783715 6.30871 0.500063 7.49961 0.5ZM7.49961 2.5C6.04091 2.5 4.64197 3.07946 3.61052 4.11091C2.57907 5.14236 1.99961 6.54131 1.99961 8C1.99961 9.45869 2.57907 10.8576 3.61052 11.8891C4.64197 12.9205 6.04091 13.5 7.49961 13.5C8.9583 13.5 10.3572 12.9205 11.3887 11.8891C12.4201 10.8576 12.9996 9.45869 12.9996 8C12.9996 6.54131 12.4201 5.14236 11.3887 4.11091C10.3572 3.07946 8.9583 2.5 7.49961 2.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.0949a56f53c006ede2d89d0588b9aa07.svg";
export { ForwardRef as ReactComponent };